import { useEffect, useState } from "react"
import { Visitor } from "./visitor-dto"
import { VisitorApi } from "./visitor-api"

export const VistorList = ({ onClose, onSelect }: { onClose: () => void, onSelect: (visitor?: Visitor) => void }) => {

    const [visitors, setVisitors] = useState<Visitor[]>([])
    const [selectedVisitor, setSelectedVisitor] = useState<Visitor>()
    useEffect(() => {
        VisitorApi.visitorList().then(d => {
            // alert(JSON.stringify(d))
            setVisitors(d.data.data)

        })
    }, [])

    return <div id="add-team-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto p-10">
            <div className="mb-8">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl text-neutral-800">Recent Visitors</h3>
                </div>

                <div className="bg-white rounded-lg border border-neutral-200 shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-neutral-200">
                            <thead className="bg-neutral-50">
                                <tr>
                                    <th></th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Name</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Contact</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Last Visit Date</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Service</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Status</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs text-neutral-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-neutral-200">
                                {visitors.map(v => <tr>
                                    <td className="px-6 py-4">
                                        <input
                                            type="checkbox"
                                            checked={selectedVisitor === v}
                                            onChange={(e) =>
                                                setSelectedVisitor(v)
                                            }
                                            className="accent-neutral-800 w-5 h-5 rounded border-neutral-300"
                                        />
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <img src="https://api.dicebear.com/7.x/notionists/svg?scale=200&amp;seed=1001" alt="Sarah Johnson" className="h-8 w-8 rounded-full" />
                                            <div className="ml-4">
                                                <div className="text-sm text-neutral-900">{v.visitor_full_name}</div>
                                                <div className="text-sm text-neutral-500">Family of 3</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">{v.emails?.join(",")}</div>
                                        <div className="text-sm text-neutral-500">{v.phones?.join(",")}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">June 4, 2025</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">Sunday Morning</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="px-2 inline-flex text-xs leading-5 rounded-full bg-neutral-100 text-neutral-800">
                                            Follow-up Needed
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500">
                                        <div className="flex space-x-2">
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-phone"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-envelope"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-ellipsis-v"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>)}
                                {/* <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <img src="https://api.dicebear.com/7.x/notionists/svg?scale=200&amp;seed=1002" alt="Michael Rodriguez" className="h-8 w-8 rounded-full" />
                                            <div className="ml-4">
                                                <div className="text-sm text-neutral-900">Michael Rodriguez</div>
                                                <div className="text-sm text-neutral-500">Single</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">mike.r@example.com</div>
                                        <div className="text-sm text-neutral-500">(555) 987-6543</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">June 4, 2025</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">Wednesday Night</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="px-2 inline-flex text-xs leading-5 rounded-full bg-neutral-100 text-neutral-800">
                                            Contacted
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500">
                                        <div className="flex space-x-2">
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-phone"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-envelope"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-ellipsis-v"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <img src="https://api.dicebear.com/7.x/notionists/svg?scale=200&amp;seed=1003" alt="Emily Chen" className="h-8 w-8 rounded-full" />
                                            <div className="ml-4">
                                                <div className="text-sm text-neutral-900">Emily Chen</div>
                                                <div className="text-sm text-neutral-500">Family of 2</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">emily.c@example.com</div>
                                        <div className="text-sm text-neutral-500">(555) 234-5678</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">June 3, 2025</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">Sunday Morning</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="px-2 inline-flex text-xs leading-5 rounded-full bg-neutral-100 text-neutral-800">
                                            Connected
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500">
                                        <div className="flex space-x-2">
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-phone"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-envelope"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-ellipsis-v"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <img src="https://api.dicebear.com/7.x/notionists/svg?scale=200&amp;seed=1004" alt="David Thompson" className="h-8 w-8 rounded-full" />
                                            <div className="ml-4">
                                                <div className="text-sm text-neutral-900">David Thompson</div>
                                                <div className="text-sm text-neutral-500">Single</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">david.t@example.com</div>
                                        <div className="text-sm text-neutral-500">(555) 876-5432</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">June 2, 2025</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-neutral-900">Sunday Evening</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="px-2 inline-flex text-xs leading-5 rounded-full bg-neutral-100 text-neutral-800">
                                            No Response
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500">
                                        <div className="flex space-x-2">
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-phone"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-envelope"></i>
                                            </button>
                                            <button className="text-neutral-600 hover:text-neutral-900">
                                                <i className="fa-solid fa-ellipsis-v"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="bg-neutral-50 px-6 py-3 flex items-center justify-between">
                        <div className="text-sm text-neutral-500">
                            Showing 4 of 18 recent visitors
                        </div>
                        <div className="flex space-x-2">
                            <button className="px-3 py-1 border border-neutral-300 rounded-md text-neutral-600 bg-white">
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>
                            <button className="px-3 py-1 border border-neutral-300 rounded-md text-neutral-600 bg-white">
                                <i className="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex items-center  justify-end my-4">
                    <div className="flex space-x-3 justify-end">
                        <button id="select-visitor-btn" className="px-4 py-2 bg-neutral-400 text-white rounded-md hover:bg-neutral-700 flex items-center" onClick={() => {
                            onClose()
                        }}>
                            <i className="fa-solid fa-user-check mr-2"></i>
                            Cancel
                        </button>
                        <button id="select-visitor-btn" className="px-4 py-2 bg-neutral-800 text-white rounded-md hover:bg-neutral-700 flex items-center" onClick={() => {
                            onSelect(selectedVisitor)
                            onClose()
                        }}>
                            <i className="fa-solid fa-user-check mr-2"></i>
                            Select Visitor
                        </button>
                        {/* <span className="text-neutral-700 flex items-center hover:underline cursor-pointer">
                            View All <i className="fa-solid fa-arrow-right ml-1"></i>
                        </span> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
}